import { Component, Input, OnInit } from '@angular/core';
import { RecursivePartial } from '@models/apollo';
import { TranslateService } from '@ngx-translate/core';
import {
  BookDuringPurchaseEnum,
  CartItem,
  CourseItem,
  IlCourse,
  PendingIlBookingReservation,
  Product
} from '@queries/generated';
import { ILBookingService } from '@services/instructor-led/il-booking.service';
import { ShoppingCartService } from '@services/shopping-cart.service';
import { MessageService } from 'primeng/api';

interface BookingItem {
  product: Product;
  courseItem: CourseItem;
  ilCourse: IlCourse;
  bookingRequired: boolean;
  pendingBookings: PendingIlBookingReservation[];
}

@Component({
  selector: 'vnm-checkout-booking-cart-item',
  templateUrl: './checkout-booking-cart-item.component.html',
  styleUrls: ['./checkout-booking-cart-item.component.scss']
})
export class CheckoutBookingCartItemComponent implements OnInit {
  @Input() item: CartItem;

  bookingItems: BookingItem[] = [];

  constructor(
    private ilBookingService: ILBookingService,
    private shoppingCartService: ShoppingCartService,
    private messageService: MessageService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    if (this.item) {
      if (this.item.product.type !== 'bundle') {
        this.addItemsToCourseItems(this.item.product);
      } else {
        this.item.product.bundledProducts.forEach((product) => {
          this.addItemsToCourseItems(product);
        });
      }
    }
  }

  onSelectClass(args: RecursivePartial<PendingIlBookingReservation>) {
    this.ilBookingService
      .createPendingReservation({
        cartItemId: this.item.gid,
        courseItemId: args.courseItem.gid,
        ilClassId: args.ilClass.gid
      })
      .subscribe(
        () => {
          this.messageService.add({
            severity: 'success',
            summary: this.translateService.instant('checkout-booking-cart-item.booked')
          });
          this.shoppingCartService.refresh();
        },
        (errors) => {
          this.messageService.add({
            severity: 'error',
            summary: errors.message
          });
        }
      );
  }

  private addItemsToCourseItems(product: Product) {
    product.course.courseItems.forEach((courseItem) => {
      if (courseItem.ilCourse) {
        this.bookingItems.push({
          product,
          courseItem,
          ilCourse: courseItem.ilCourse,
          bookingRequired: product.bookDuringPurchase === BookDuringPurchaseEnum.Enforced,
          pendingBookings: this.item.pendingIlBookingReservations.filter(
            (booking) => booking.courseItem.id === courseItem.id
          )
        });
      }
    });
  }
}
